/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NetConnectWifiIcon20Light = forwardRef('NetConnectWifiIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M10 5a10 10 0 0 0-7.4 3.274.5.5 0 1 1-.74-.673 11 11 0 0 1 16.28 0 .5.5 0 1 1-.74.673A10 10 0 0 0 10 5Z" }),
        React.createElement("path", { d: "M10 10a5 5 0 0 0-3.842 1.8.5.5 0 0 1-.769-.639 6 6 0 0 1 9.222 0 .5.5 0 0 1-.769.64A5 5 0 0 0 10 10Z" }),
        React.createElement("path", { d: "M10 16a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" })));
});
